const tech_img = require('../../assets/img/tutorials/mnn/tech.png');
const secondary_tech_img = require('../../assets/img/tutorials/mnn/secondary-tech.png');
const func_img = require('../../assets/img/tutorials/mnn/func.png');
const secondary_func_img = require('../../assets/img/tutorials/mnn/secondary-func.png');

export const MNNSteps = [
    {
        name: 'Madrid Nuevo Norte',
        title: 'Descripción funcional',
        description: <span>
            <p>El gemelo digital <b>permite integrar el maquetado en 3D de diferentes propuestas urbanísticas</b> y la integración de información asociada, como, por ejemplo, la estimación de emisiones de CO2 de las distintas parcelas proyectadas al año 2030.

            </p>
            <p>A través de la <b>integración de estimaciones y modelos predictivos</b>, el sistema podría evaluar el impacto ambiental en términos de emisiones de CO2, permitiendo <b>visualizar y contrastar diferentes estrategias planificación urbana sostenible</b>, reducir la emisión de gases contaminantes y mejorar la eficiencia de los edificios. También podría aplicar en la gestión de residuos y en la implementación de espacios verdes, con el fin de crear un balance de carbono en la ciudad. Mejorando en todos los casos la gestión y planificación y la información para la ciudadanía.
            </p>
        </span>,
        secondarydescription: <span>
            <p>Área de Gobierno de Vicealcaldía, Portavoz, Seguridad  y Emergencias</p>
        </span>,
        mainimage: <img src={func_img} alt="main_func" />,
        secondaryimage: <img src={secondary_func_img} alt="sec_func" />,
    },
    {
        name: 'Madrid Nuevo Norte',
        title: 'Descripción técnica',
        description: <div>
            <span>
                Integraciones técnicas
                <ul>
                    <li><b>Integración modelos de información de construcción</b> (Building Information Modeling - BIM) para una gestión detallada del ciclo de vida de los edificios, desde su diseño hasta su construcción y mantenimiento.</li>
                    <li><b>Integración de cartografía 2D y 3D</b>, permitiendo una representación detallada del espacio urbano y la interpretación de patrones geoespaciales.
</li>
                </ul>
            </span>
            <span>
                Origen de Datos
                <ul>
                    <li>Utilización de la <b>base de datos para obtener información geoespacial</b> precisa que apoya en la planificación y el desarrollo urbano y territorial.</li>
                    <li><b>Datos Específicos sobre Emisiones de CO2</b> de nuevas zonas en Madrid, para evaluar el impacto ambiental y fomentar prácticas de construcción y consumo sostenible.</li>

                </ul>
            </span>



        </div>,
        mainimage: <img src={tech_img} alt="main_tech" />,
        secondaryimage: <img src={secondary_tech_img} alt="sec_tech" />,
    }
];